<template>
  <v-data-table :headers="headers" :items="workstations">
    <template v-slot:top>
      <FormDialog :dialog="create_dialog" :close="closeCreateDialog" :title="modal_title">
        <FormWorkstation :editData="workstation_selected" :closeDialog="closeCreateDialog" />
      </FormDialog>
      <div class="d-flex justify-end">
        <v-btn color="green lighten-1" dark class="my-2" @click="openCreate">
          <v-icon class="mr-1">mdi-plus</v-icon>
          Criar</v-btn
        >
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapState } from 'vuex'
import FormDialog from '@/components/dialogs/FormDialog.vue'
import FormWorkstation from './FormWorkstation.vue'

export default {
  name: 'WorkstationList',
  components: { FormDialog, FormWorkstation },
  data: () => {
    return {
      workstation_selected: {},
      create_dialog: false,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Vínculo', value: 'workstation' },
        { text: 'Ações', value: 'actions' },
      ],
    }
  },
  computed: {
    ...mapState('utils', ['workstations']),
    modal_title() {
      if (this.workstation_selected.workstation) {
        return 'Editar Vínculo'
      } else {
        return 'Cadastrar Vínculo'
      }
    },
  },
  methods: {
    openCreate() {
      this.create_dialog = true
    },
    closeCreateDialog() {
      this.create_dialog = false
      this.workstation_selected = {}
    },
    editItem(data) {
      this.workstation_selected = data
      this.openCreate()
    },
  },
}
</script>
